<template lang="html">
  <v-card class="feedback mx-3 px-3">
    <v-card-title>
      <h2>Feedback</h2>
    </v-card-title>
    <v-card-text>
      <span class="feedback_desc">
        Please suggest corrections or improvement here. For every suggestion
        we utilize to improve our platform, PBLMed.com will donate a portion
        of the funds received from your organization to the charity you
        specify here.
      </span>
      <v-textarea outlined label="Enter your feedback here" class="mt-6" v-model="feedback_txt" multi-line />
      <v-radio-group v-model="charity" class="charity">
        <template v-slot:label>
          <div style="font-size: 16px;"><strong>Select a charity you want to support:</strong></div>
        </template>
        <v-radio v-for="c in charities" :key="c.name" :value="c.name" :color="c.color" :label="c.name" />
      </v-radio-group>
      <h3>About you:</h3>
      <v-row class="mt-3">
        <v-text-field outlined class="mx-3" v-model="name" label="Name" />
        <v-text-field outlined class="mr-3" v-model="email" label="Email" />
        <v-text-field outlined class="mr-3" v-model="phone" label="Phone" />
      </v-row>
    </v-card-text>
    <v-card-actions>
      <div class="feedback__actions">
        <v-btn text class="mr-10">Cancel</v-btn>
        <v-btn text color="primary" @click.native="sendFeedback()">Send</v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      name: '',
      email: '',
      phone: '',
      feedback_txt: '',
      color: 'success',
      snackbar: false,
      success: false,
      charities: [
        {
          name: 'American Humane (https://www.americanhumane.org/)',
          color: 'blue'
        },
        {
          name: 'Breast Cancer Research Foundation (https://www.bcrf.org/)',
          color: 'blue'
        },
        {
          name: 'Marine Toys for Tots (https://www.toysfortots.org/)',
          color: 'blue'
        },
        {
          name: 'Earthworks (https://earthworks.org/)',
          color: 'blue'
        },
        {
          name: 'National Park Foundation (https://www.nationalparks.org/)',
          color: 'blue'
        },
        {
          name: 'Sierra Club (https://www.sierraclub.org/)',
          color: 'blue'
        },
        {
          name: 'Doctors Without Borders (https://www.doctorswithoutborders.org/)',
          color: 'blue'
        },
        {
          name: 'I can’t decide',
          color: 'red'
        }
      ],
      charity: ''
    }
  },
  methods: {
    sendFeedback () {
      let charityInfo = `\nCharity: ${this.charity}.`
      let data = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        feedback_txt: this.feedback_txt + charityInfo
      }
      console.log(data)
      this.$store.dispatch('sendFeedback', data)
    }
  },
  created () {
    this.$store.dispatch('changeShowToolbar', true)
  }
}
</script>

<style lang='css'>
.feedback {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  /* width: 70%; */
  /* margin: 0 auto; */
  /* padding-left: 5%;
  padding-right: 5%; */
  align-items: center;
}
.feedback_desc {
  font-size: 18px;
}
.feedback__actions {
  /* display: flex; */
  margin: 0 auto;
  justify-content: space-evenly;
}
.v-text-field {
  margin: 0 auto;
}
label {
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Feedback.vue